import React from "react";
import SignInLayer from "../../components/SignInLayer";
import { useAuth } from "../../auth/AuthProvider";
import { Navigate } from "react-router-dom";

const SignInPage = () => {
  const auth = useAuth();

  if(auth.isAuthenticated){
    return <Navigate to="/" />;
  }

  return (
    <>
      <SignInLayer />
    </>
  );
};

export default SignInPage; 
